import {Injectable} from '@angular/core';
import {NavController} from '@ionic/angular';
import { App } from '@capacitor/app';
import {isSamlCallbackUrl} from '../utils/saml-callback';

@Injectable({
    providedIn: 'root'
})
export class DeepLinkingService {

    constructor(
        private readonly navCtrl: NavController
    ) {
    }

    registerDeepLinking() {
        App.addListener('appUrlOpen', (data: any) => {
            this.handleDeepLinkingUrl(data.url);
        });
    }

    public async handleDeepLinking() {
        const launchUrl = await App.getLaunchUrl();
        if (launchUrl?.url) {
            this.handleDeepLinkingUrl(launchUrl.url);
        }
    }

    private handleDeepLinkingUrl(url: string) {
        if (isSamlCallbackUrl(url)) {
            return;
        }
        this.navCtrl.navigateForward(url);
    }

}
